export default __webpack_public_path__ + "static/media/campaigns-upcoming-empty.2e44af60.svg";